import React from 'react';
import { ArrowRight, Check } from 'lucide-react';
import PersonAvatar from './PersonAvatar';

export interface BillPaymentPerson {
  id: string;
  name: string;
  avatarUrl?: string;
  amountLabel: string;
  status?: string;
  disabled?: boolean;
}

/** People selection within the public bill payment review. */
export default function BillPaymentPeople({ people, selectedIds, onToggle, totalLabel, onContinue, canContinue, continueLabel = 'Continue' }: {
  people: BillPaymentPerson[];
  selectedIds: string[];
  onToggle: (id: string) => void;
  totalLabel: string;
  onContinue: () => void;
  canContinue: boolean;
  continueLabel?: string;
}) {
  return <>
    <div className="bill-selection-list">
      {people.map((person, index) => (
        <button key={person.id} type="button" className="bill-person-row bill-selection-row"
          aria-pressed={!person.disabled && selectedIds.includes(person.id)} disabled={person.disabled}
          onClick={() => onToggle(person.id)}>
          <span className="bill-selection-check" aria-hidden="true">{!person.disabled && selectedIds.includes(person.id) && <Check size={14} />}</span>
          <PersonAvatar name={person.name} src={person.avatarUrl} identifier={person.id} />
          <span className="bill-person-row__person"><strong>{person.name}</strong>{person.status && <span>{person.status}</span>}</span>
          <span className="bill-person-row__amount">{person.amountLabel}</span>
        </button>
      ))}
    </div>
    <div className="bill-selection-total" aria-live="polite"><span>{selectedIds.length} selected</span><strong>{totalLabel}</strong></div>
    <button type="button" disabled={!canContinue} onClick={onContinue} className="vs-button vs-button--primary vs-button--full">
      {continueLabel} <ArrowRight size={19} aria-hidden="true" />
    </button>
  </>;
}
